import {
    HOME_CARD_GROUP_FEATURES,
    isPlanFeatureOff,
    isPlanManaged
} from "@/common/fields/plan-features";

// billing-fase5-salida-planes: lo que el plan incluye pero el tenant tiene
// apagado ("Mis funciones") no se muestra. Solo para tenants del modelo de
// planes; el resto sigue viendo lo que su rol permite. Sin `subscription` en
// la sesion (super sin tenant, tenant sin fila de plan) no hay
// `featureFlags` que respetar: todos vendrian apagados y ocultarian el menu.
const _hiddenByFeatureFlag = (rootState, feature) =>
    Boolean(feature) &&
    Boolean(rootState.auth.subscription) &&
    isPlanManaged(rootState.auth.permissions) &&
    isPlanFeatureOff(rootState.auth.featureFlags, feature);

const getters = {
    borderCardDark(state) {
        return state.activeDark ? "border-warning" : "border-theme-success";
    },
    tableDark(state) {
        return state.activeDark ? "table-dark" : "table-light";
    },
    stateInputDark(state) {
        return state.activeDark ? "success" : "primary";
    },
    backgroundColorTextArea(state) {
        return state.activeDark ? "bg-input-success" : "bg-input-primary";
    },
    backgroundColor(state) {
        return state.activeDark ? "#0a1f3b" : "#f3f5f4";
    },
    visibleSidebarItems(state, _getters, rootState) {
        return state.sidebarItems.filter(
            (item) =>
                item.locked || !_hiddenByFeatureFlag(rootState, item.feature)
        );
    },
    isCardLinkVisible(_state, _getters, rootState) {
        return (link) =>
            !_hiddenByFeatureFlag(
                rootState,
                HOME_CARD_GROUP_FEATURES[link.group]
            );
    }
};

export default getters;
